/* Distraction-free print preview: only the artwork, on the film. */

import { useEffect, useState } from 'react';
import { formatDims } from '@gsb/core';
import { useStore, setActiveSheet, setCanvasBg, type CanvasBg } from '../store/store';
import { SheetCanvas, type CanvasApi } from '../canvas/SheetCanvas';
import { Icon } from '../ui/icons';
import { Seg } from '../ui/primitives';

export function PreviewMode() {
  const sheets = useStore(s => s.doc.sheets);
  const active = useStore(s => s.activeSheet);
  // the same Film / Dark / White choice as the canvas (view only; never printed)
  const bg = useStore(s => s.canvasBg);
  const [api, setApi] = useState<CanvasApi | null>(null);
  const close = () => useStore.setState({ preview: false });
  useEffect(() => {
    const k = (e: KeyboardEvent) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, []);
  const s = sheets[active];
  return (
    <div className="pview" role="dialog" aria-label="Print preview">
      <div className="pview-bar">
        <span className="kicker no-phone">Print preview</span>
        {sheets.length > 1 && (
          <select className="in in-sm" style={{ width: 'auto' }} value={active} onChange={e => setActiveSheet(Number(e.target.value))} aria-label="Sheet">
            {sheets.map((x, i) => <option key={x.id} value={i}>Sheet {i + 1} · {formatDims(x.widthMm, x.lengthMm, 'cm')}</option>)}
          </select>
        )}
        {s && <span className="small muted no-phone">{formatDims(s.widthMm, s.lengthMm, 'cm')} · {s.items.length} transfers · what prints is exactly this</span>}
        <span className="grow" />
        <Seg<CanvasBg> label="Background" value={bg} onChange={setCanvasBg} options={[{ value: 'checker', label: 'Film' }, { value: 'dark', label: 'Dark' }, { value: 'white', label: 'White' }]} />
        <button className="ibtn" aria-label="Fit sheet" data-tip="Full sheet" onClick={() => api?.fit()}><Icon name="fit" /></button>
        <button className="ibtn" aria-label="Real size" data-tip="100%" onClick={() => api?.actual()}><Icon name="zoomIn" /></button>
        <button className="btn btn-line btn-sm" onClick={close}><Icon name="x" />Close</button>
      </div>
      {s && <SheetCanvas sheetIndex={active} mode="view" background={bg} onApi={setApi} showMinimap clean />}
    </div>
  );
}
